import AccumActOverlay from '../account-overlay/account-overlay.vue';

export default {
  name: 'pension-account',
  components: {
    AccumActOverlay,
  },
  props: {
    pension: {
      type: Object,
      required: true,
    },
    nonTaxablePercent: {
      type: Number,
      default: 0,
    },
    pensionNotReq: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    activePension() {
      return this.getItem.activePension;
    },
    state() {
      return this.pension.status;
    },
    isPartOne() {
      return this.getItem.setup.part === 'PART_1';
    },
    isFixedAmount() {
      return this.getItem.setup.howMuch === 'A fixed amount';
    },
    amount() {
      return this.isFixedAmount ? this.pension.fixedAmount : this.pension.amount;
    },
    menuActions() {
      return ['Edit'];
    },
  },
  methods: {
    handleMenuAction(action) {
      switch (action) {
        case 'Edit':
          this.$emit('action', 'edit');
          break;
        default:
          console.warn('PENSION_ACCOUNT::Unknown menu action');
      }
    },
    handleStartPension() {
      this.$emit('action', 'start');
    },
  },
};
